<template>
	<div id="press-releases">
		<div class="container">
			<div class="breadcrumbs">
				<div class="breadcrumbs__item">{{ $t('main.press-releases.about-nexon') }}</div>
				<div class="breadcrumbs__separator"></div>
				<div class="breadcrumbs__item">{{ $t('main.press-releases.title') }}</div>
			</div>
			<div class="about-logo">
				<img src="@/images/corporate/about/logo.png" />
			</div>

			<div class="tagline">
				<span>{{ $t('main.press-releases.title') }}</span>
			</div>

			<div v-if="loading" class="spinner-wrapper">
				<div class="spinner-circle"></div>
			</div>

			<template v-else>
				<router-link class="press-featured" :to="{ name: 'pressReleasesArticle', params: { articleId: featured.Id } }">
					<div class="press-featured__left">
						<div class="press-featured__image" :style="{ backgroundImage: `url(${featured.ImageThumbnail})` }"></div>
					</div>
					<div class="press-featured__right">
						<div class="press-featured__header">
							<div class="press-featured__game" :class="featured.Category.toLowerCase().replace(/\s/g, '')">
								{{ featured.Category }}
							</div>
							<div class="press-featured__date">
								{{ featured.LiveDate | formatedDate }}
							</div>
						</div>
						<div class="press-featured__title">{{ featured.Title }}</div>
						<div class="press-featured__description">{{ featured.Summary }}</div>
					</div>
				</router-link>

				<div class="press-list">
					<div class="press-list__item press-list__item--header">
						<div class="press-list__item__category">{{ $t('main.press-releases.category') }}</div>
						<div class="press-list__item__headline">{{ $t('main.press-releases.headline') }}</div>
						<div class="press-list__item__date">{{ $t('main.press-releases.date') }}</div>
					</div>

					<router-link
						v-for="item in displayedItems"
						:key="item.Id"
						class="press-list__item"
						:to="{ name: 'pressReleasesArticle', params: { articleId: item.Id } }"
					>
						<div class="press-list__item__category" :class="item.Category.toLowerCase().replace(/\s/g, '')">
							{{ item.Category }}
						</div>
						<div class="press-list__item__headline">{{ item.Title }}</div>
						<div class="press-list__item__date">{{ item.LiveDate | formatedDate }}</div>
					</router-link>
				</div>

				<div class="pagination-wrapper">
					<Paginate
						v-if="clientWidth > 1024"
						v-model="page"
						:page-count="totalPageCount"
						:page-class="'page-number'"
						:prev-class="'pagination-prev-page'"
						:next-class="'pagination-next-page'"
						:container-class="'pagination'"
					>
					</Paginate>
					<button v-else-if="itemsPerPage < items.length" class="load-more" @click="itemsPerPage += 10">
						{{ $t('main.press-releases.load-more') }}
					</button>
				</div>
			</template>

			<div class="util-wrapper">
				<div class="contact">
					<div class="contact__item">{{ $t('main.press-releases.media-contact-info') }}:</div>
					<div class="contact__item">
						{{ $t('main.about-nexon.nexon-america') }}
					</div>
					<div class="contact__item">
						NA_pr@nexon.com
					</div>
				</div>
				<div class="gptw-badge"></div>
			</div>

			<div class="links">
				<router-link :to="{ name: 'aboutNexon' }">
					{{ $t('main.press-releases.about-nexon') }}
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import moment from 'moment';

export default {
	name: 'PressReleases',
	components: {
		Paginate,
	},
	filters: {
		formatedDate: (date) => {
			return moment(date).format('MMM D, YYYY');
		},
	},
	data() {
		return {
			items: [],
			page: 1,
			itemsPerPage: 10,
			loading: false,
			clientWidth: 0,
		};
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('main.about-nexon.press-releases')}`,
		};
	},
	computed: {
		totalPageCount() {
			return Math.ceil(this.items.length / this.itemsPerPage) || 1;
		},
		displayedItems() {
			return this.items.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage);
		},
		featured() {
			let featured = this.items.filter((item) => item.FeaturedNews === true)[0];
			return featured ? featured : this.items[0];
		},
	},
	watch: {
		clientWidth(val) {
			if (val <= 1024) {
				this.page = 1;
			} else {
				this.itemsPerPage = 10;
			}
		},
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	created() {
		this.loading = true;
		this.$cdnAPI.get('/corporate/press').then((response) => {
			this.items = response.data;
			this.loading = false;
		});
		this.handleResize();
	},
	methods: {
		handleResize() {
			this.clientWidth = window.innerWidth;
		},
	},
};
</script>

<style lang="scss" scoped>
@font-face {
	font-family: arrow-icons;
	src: url('data:application/font-woff;charset=utf-8;base64, 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');
	font-weight: 400;
	font-style: normal;
}

#press-releases {
	background-color: #121212;
	background-repeat: no-repeat;
	background-image: radial-gradient(circle at top, #276a60, #1a3530, #15191a, #121212 35%);
	padding-top: 56px;
	padding-bottom: 100px;
	line-height: normal;

	.container {
		max-width: 1024px;
		width: 100%;
		margin: 0 auto;
		padding-bottom: 100px;
		font-size: 12px;
		padding: 0;
	}

	.breadcrumbs {
		display: flex;
		font-size: 18px;
		margin: 20px 0 0;
		&__item {
			color: #fff;
			text-decoration: none;
		}
		&__separator {
			margin: 3px 20px 0;
			width: 2px;
			height: 14px;
			background-color: #22544b;
		}
	}

	.about-logo {
		margin-top: 60px;
		text-align: center;
		img {
			width: 500px;
		}
	}

	.tagline {
		margin-top: 80px;
		text-align: center;
		line-height: normal;
		span {
			background: linear-gradient(90deg, #8ee692, #2f80e0 20%, #2f80e0 70%, #8ee692);
			background-clip: text;
			-webkit-text-fill-color: transparent;
			text-transform: uppercase;
			letter-spacing: 4px;
			font-size: 53px;
			font-family: KlavikaNX Light;
		}
	}

	.press-featured {
		display: flex;
		flex-wrap: wrap;
		margin-top: 40px;
		text-decoration: none;
		&:hover {
			opacity: 0.9;
		}
		&__left {
			.press-featured__image {
				border: 1px solid #3bbeac;
				width: 300px;
				height: 200px;
				background-position: 50%;
				background-size: cover;
			}
		}
		&__right {
			margin-left: 20px;
			flex-basis: 0;
			flex-grow: 1;
			max-width: 100%;
			.press-featured__header {
				display: flex;
				flex-wrap: wrap;
				font-size: 18px;
			}
			.press-featured__game {
				text-transform: uppercase;
				color: #fff;
			}
			.press-featured__date {
				color: #adadad;
				margin-left: 30px;
			}
			.press-featured__title {
				margin-top: 10px;
				font-size: 22px;
				color: #fff;
				line-height: 30px;
			}
			.press-featured__description {
				margin-top: 10px;
				color: #adadad;
				font-size: 18px;
				line-height: 25px;
			}
		}
	}

	.press-list {
		margin-top: 50px;
		border-top: 2px solid #1f423e;
		border-bottom: 2px solid #1f423e;
		&__item {
			display: flex;
			padding: 15px 0;
			font-size: 16px;
			text-align: center;
			color: #adadad;
			border-top: 1px solid #1f423e;
			background-repeat: no-repeat;
			cursor: pointer;
			transition: all 0.2s;
			&:first-child {
				border-top: none;
			}
			&:hover {
				color: #39ae9b;
				background-image: linear-gradient(90deg, #121212, #1b3833, #121212);
			}
			&--header {
				background-image: linear-gradient(90deg, #121212, #151b1b, #121212);
				&:hover {
					cursor: default;
					background-image: linear-gradient(90deg, #121212, #151b1b, #121212);
				}
			}
			&__category {
				flex: 0 0 13%;
				max-width: 13%;
				text-transform: uppercase;
			}
			&__headline {
				flex: 0 0 76%;
				max-width: 76%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 0 40px;
			}
			&__date {
				flex: 0 0 11%;
				max-width: 11%;
			}
		}
	}

	.general {
		color: #fff !important;
	}
	.maplestory {
		color: #9d352c !important;
	}
	.maplestory2 {
		color: #ffea3c !important;
	}
	.maplestorym {
		color: #e67d39 !important;
	}
	.mabinogi {
		color: #80dafd !important;
	}

	.pagination-wrapper ::v-deep {
		text-align: center;
		.pagination {
			.pagination-prev-page,
			.pagination-next-page {
				&.disabled {
					opacity: 0.5;
				}
				a {
					background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.25 36'><path fill='%23fff' d='M19.29,24l14.2-14.2a2.23,2.23,0,1,0-3.16-3.15L14.55,22.45a2.23,2.23,0,0,0,0,3.15L30.33,41.37a2.23,2.23,0,1,0,3.16-3.15Z' transform='translate(-13.9 -6.03)'/></svg>")
						no-repeat top left;
					height: 14px;
					width: 14px;
					color: transparent;
					font-size: 0;
					margin-top: 9px;
					opacity: 0.5;
					transition: 0.3s ease;
					&:hover,
					&:focus {
						opacity: 1;
						color: transparent;
						background-color: transparent;
					}
				}
			}
			.pagination-prev-page {
				a {
					background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.25 36'><path fill='%23fff' d='M19.29,24l14.2-14.2a2.23,2.23,0,1,0-3.16-3.15L14.55,22.45a2.23,2.23,0,0,0,0,3.15L30.33,41.37a2.23,2.23,0,1,0,3.16-3.15Z' transform='translate(-13.9 -6.03)'/></svg>")
						no-repeat top left;
				}
			}
			.pagination-next-page {
				a {
					margin-left: 10px;
					background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.25 36'><path fill='%23fff' d='M33.49,22.45,17.7,6.68a2.23,2.23,0,0,0-3.15,3.16L28.75,24,14.55,38.22a2.23,2.23,0,1,0,3.15,3.15L33.49,25.6A2.23,2.23,0,0,0,33.49,22.45Z' transform='translate(-13.89 -6.03)'/></svg>")
						no-repeat top right;
				}
			}
			.page-number {
				> a {
					color: #d9d9d9;
					background-color: transparent;
					border-color: transparent;
					&:hover {
						background-color: #d9d9d9;
						border-color: #d9d9d9;
						color: #000;
					}
				}
				&.active {
					> a {
						background-color: #d9d9d9;
						border-color: #d9d9d9;
						color: #000;
					}
				}
			}
		}

		.load-more {
			min-width: 360px;
			background-color: transparent;
			border: 1px solid #40d0ba;
			color: #40d0ba;
			flex-basis: 47%;
			max-width: 47%;
			padding-top: 9px;
			padding-bottom: 9px;
			text-transform: uppercase;
			// font-size: 24px;
			font-size: 16px;
			text-align: center;
			border-radius: 40px;
			text-decoration: none;
			transition: 0.2s;
			margin-top: 30px;
			font-family: 'KlavikaNX Light';
			&:hover {
				background-color: #40d0ba;
				color: #000;
				cursor: pointer;
			}
			&:active {
				opacity: 0.6;
			}
		}
	}

	.util-wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin-top: 20px;
		.contact {
			text-align: center;
			color: #fff;
			font-size: 18px;
			margin-top: 50px;
			&__item {
				margin-bottom: 5px;
				&:first-child {
					color: #adadad;
				}
			}
		}
		.gptw-badge {
			display: inline-block;
			background-image: url('~@/images/corporate/badge-great-place-to-work.png');
			background-repeat: no-repeat;
			background-position-x: 50%;
			background-position-y: center;
			background-size: 100%;
			width: 123px;
			height: 200px;
			margin-left: 28px;
		}
	}

	.links {
		display: flex;
		flex-wrap: wrap;
		flex: 0 1 auto;
		line-height: normal;
		justify-content: center;
		margin-top: 100px;
		font-family: 'KlavikaNX Light';

		a {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #fff;
			color: #212121;
			min-width: 310px;
			padding: 10px 20px;
			text-transform: uppercase;
			font-size: 24px;
			border-radius: 40px;
			text-decoration: none;
			transition: 0.2s;
			&:hover {
				background-color: #40d0ba;
			}
			&:before {
				font-family: arrow-icons;
				text-transform: none;
				content: 'prev';
				font-size: 18px;
				margin-right: 20px;
			}
		}
	}
	.spinner-wrapper {
		display: flex;
		justify-content: center;
		padding: 300px 0;
		.spinner-circle {
			width: 60px;
			height: 60px;
			border: 10px solid #999;
			border-top: 10px solid #0077ff;
		}
	}
}

@media only screen and (max-width: 1024px) {
	#press-releases {
		.container {
			max-width: 100%;
			padding-left: 20px;
			padding-right: 20px;

			.breadcrumbs {
				line-height: normal;
				font-size: 16px;
				&__item {
					padding: 0;
				}
				&__separator {
					margin: 3px 10px 0;
				}
			}

			.about-logo {
				margin-top: 30px;
				img {
					width: 100%;
				}
			}

			.tagline {
				margin-top: 40px;
				span {
					font-size: 35px;
				}
			}

			.press-featured {
				margin-top: 20px;
				flex-direction: column;

				&__left {
					.press-featured__image {
						width: 100%;
						height: 200px;
					}
				}
				&__right {
					margin-top: 10px;
					margin-left: 0px;
					.press-featured__title,
					.press-featured__description {
						margin-top: 5px;
					}
				}
			}

			.press-list {
				margin-top: 20px;
				&__item {
					flex-wrap: wrap;
					text-align: left;

					&--header {
						display: none;
					}
					&:nth-child(2) {
						border-top: none;
					}

					&__category {
						flex: 0 0 auto;
						width: auto;
						max-width: none;
						order: 1;
					}
					&__headline {
						flex: 0 0 100%;
						max-width: 100%;
						order: 3;
						padding: 0;
					}
					&__date {
						flex: 0 0 auto;
						width: auto;
						max-width: none;
						order: 2;
						margin-left: 20px;
					}
				}
			}

			.links {
				margin-top: 50px;
				a {
					min-width: 360px;
					font-size: 16px;
					&:before {
						font-size: 14px;
						margin-right: 10px;
					}
				}
			}
		}
	}
}

@media (max-width: 500px) {
	#press-releases {
		.container {
			.links {
				a {
					min-width: 100%;
					width: 100%;
				}
			}
		}
		.pagination-wrapper {
			.load-more {
				min-width: 100%;
				max-width: 100%;
			}
		}
	}
}
</style>
